module.exports = __webpack_public_path__ + "static/media/circle-right5.5d1295db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/circle-right5.svg
// module id = 2602
// module chunks = 7